export default {"src":"/_next/static/image/components/ui/Icon/icons/arrow-button.6d64cdf62d6ecdd2bcfcc9611d388921.svg","height":18,"width":11};